import { BreadcrumbSchema } from '@/components/JsonLd';
import CompanyStory from '@/components/evRedesign/CompanyStory';
export default function About() {
  return <><BreadcrumbSchema items={[{ name: 'Forside', path: '/' }, { name: 'Om enkel', path: '/about' }]} /><CompanyStory /></>;
}